const wrongFormatMessage = 'skal være korrekt format';
const fieldRequiredMessage = 'skal være udfyldt';

// Validation from: https://starwiki.atlassian.net/wiki/spaces/FYS/pages/3594387514/ActivityService+Version+6+2022-1
export const emailRegex = /([^>\(\)\[\]\\,;:@\s]{0,191}@[^>\(\)\[\]\\,;:@\s]{1,64})/;
export const phoneRegex = /(\+)?[0-9]{3,20}/;
export const streetBuildingIdentifierRegex = /^([1-9][0-9]{0,2}[a-zA-Z]?)(-[1-9][0-9]{0,2}[a-zA-Z]?)?$/;
export const postCodeRegex = /[0-9]{4}/;
export const floorRegex = /[1-9]|[1-9][0-9]|KL|ST|kl|st|k[2-9]|K[2-9]/;

export const fieldRequiredErrorMessage = (label: string): string => `${label} ${fieldRequiredMessage}`;
export const fieldWrongFormatErrorMessage = (label: string): string => `${label} ${wrongFormatMessage}`;
export const textFieldMaxLengthExceeded = (length: number, maxLength: number): string => `Teksten indeholder for mange tegn (${length}/${maxLength})`;
export const fieldWrongDfdgFormat = (label: string) => `${label} overholder ikke DFDG format`;

export const isEmpty = function (text?: string): boolean {
  return !text || text.trim() === '';
};

export function isFloor(floor: string) {
  return floorRegex.test(floor);
}

export function isStreetBuildingIdentifier(streetBuilding: string) {
  return streetBuildingIdentifierRegex.test(streetBuilding);
}

export function isEmail(email: string) {
  return emailRegex.test(email);
}

export function isPhone(phone: string) {
  return phoneRegex.test(phone);
}
